import React, { useEffect } from "react";
import { HOME_HTML } from "./homeMarkup";
import initHome from "./homeRuntime";
import "./home.css";

/* New Cowork Development homepage — AI product engineering positioning.
   Static markup + vanilla interactions ported from the standalone
   marketing site; other routes (/developers, /apply, /login, /admin)
   are untouched. */
const MainPage = () => {
  useEffect(() => {
    const cleanup = initHome();
    return cleanup;
  }, []);

  return <div className="cw" dangerouslySetInnerHTML={{ __html: HOME_HTML }} />;
};

export default MainPage;
